module.exports = __webpack_public_path__ + "img/centurion.c916ca87.jpg";